<div mat-dialog-content>
  <h2 class="heading-underline">
    <mat-icon fontIcon="file_upload" class="material-icons-outlined"></mat-icon>
    <span>Upload a document for {{ entityName }}</span>
  </h2>
  <main class="scrollable-container">
    <input
      #fileInput
      type="file"
      style="display: none"
      (change)="onFileSelected($event)"
      [accept]="'.pdf,.doc,.docx'"
      />
      @if (!fileSelected) {
        <button
          class="uploadButton"
          tabindex="0"
          (click)="triggerFilePicker()"
          appRipple
          >
          Upload File
          <mat-icon fontIcon="file_upload" style="vertical-align: bottom; margin-left: 5px"></mat-icon>
        </button>
      }
      @if (selectedFiles.length) {
        <app-kp-simple-table
          #simpleTable
          [items]="selectedFiles"
          [columnHeadings]="columnHeadings"
          [selectableRows]="true"
          [tableClasses]="'hover-rows large-side-padding scrollable-container'"
          (actionClick)="onActionClick($event)"
          (rowClick)="itemRowClick($event)"
        ></app-kp-simple-table>
      }
    </main>
  </div>

